<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><a id="page_5"><img alt="images" height="249" src="images/f0005-01.jpg" width="550"/></a></p><a id="page_5">
<p class="dedi"><span class="txit">To</span></p>
<p class="dedi1"><span class="txit">HAROLD C. BRYANT</span></p>
<p class="dedi1"><span class="txit">Superintendent Grand Canyon National Park</span></p>
<p class="dedi1"><span class="txit">and</span></p>
<p class="dedi1"><span class="txit">ERNIE APPLING</span></p>
<p class="dedi1"><span class="txit">Uncle Jim’s friend and a cowboy’s cowboy</span></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?3ff31267